/** Coerce API boolean flags that may arrive as true, 1, or "1". */
export function isTruthyApiFlag(value: unknown): boolean {
  return value === true || value === 1 || value === "1";
}
